<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>单号：</label>
                <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>添加时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="code" label="单号" sortable="custom"></el-table-column>
                <el-table-column prop="weight" label="重量" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看重量信息"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import {exportWeight} from "@/api/carreport"

export default {
    name: 'weightDataList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '重量信息',
            menu_id: 18100,
            list_url: "/api/admin/weightdata/list",
            search_Obj: {
                f_code: '',
                f_add_time_s_date: '',
                f_add_time_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/weightdata/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
        export(){
            var data = {
                "email": this.search_Obj.code,
                "add_time_s_date": this.search_Obj.f_add_time_s_date,
                "add_time_e_date": this.search_Obj.f_add_time_e_date
            }
            exportWeight(data).then(res=>{
                if(res.code ==1){
                    window.open(res.data)
                }else if(res.code ==990){
                    this.$msg("无数据可导出")
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>